import { render } from "./Cautionary.vue?vue&type=template&id=ebc80eee"
import script from "./Cautionary.vue?vue&type=script&lang=js"
export * from "./Cautionary.vue?vue&type=script&lang=js"

import exportComponent from "D:\\PROJECT\\Mbf5_HCC\\XaTanHungHph\\web-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__